export default __webpack_public_path__ + "static/media/purple_seal_2021.3d5e4d68.png";